import "core-js/stable";
import "regenerator-runtime/runtime";

// Import all custom modules
import ElementResizer from "resizer.js";
import Faq from "faq.js";
import "mobile-menu.js";
import "desktop-menu.js";
import "sb-search.js";
import "image.js";
import "footnotes/Footnotes.js";
import "tooltip/Tooltip.js";
import "photo-swipe";
import "iframe-resizer";
import "ads.js";
import "resizableNavigation.js";

// SearchPage
import "search";

// EventOverview
import "event-overview";

// Import stylesheets.
import "app.scss";

new ElementResizer();
new Faq(".js-faq");

